/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlEscalationPriority = {
    TierOneAllAlerts: 'TIER_ONE_ALL_ALERTS',
    TierTwoBackupAlerts: 'TIER_TWO_BACKUP_ALERTS',
    None: 'NONE'
} as const;
export type ControlEscalationPriority = typeof ControlEscalationPriority[keyof typeof ControlEscalationPriority];


export function ControlEscalationPriorityFromJSON(json: any): ControlEscalationPriority {
    return ControlEscalationPriorityFromJSONTyped(json, false);
}

export function ControlEscalationPriorityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEscalationPriority {
    return json as ControlEscalationPriority;
}

export function ControlEscalationPriorityToJSON(value?: ControlEscalationPriority | null): any {
    return value as any;
}

